
import * as types from "../actions/empTypes.js";
import * as actions from "../actions/empActions.js";

import { call, put, takeEvery } from 'redux-saga/effects';
import axiosInstance from '../../interceptor/interceptor.js'; 




//FOR UPDATING EMPLOYEE DETAILS
function* updateEmployees(action) {
  try {
   ////console.log('saga')
   ////console.log(action.payload)
    ////console.log(id)
  yield call(axiosInstance.patch, `/emp/update/${action.payload.id}`, action.payload);

    ////console.log('Updated Employee:', response.data);
    yield put(actions.updateEmployeeSuccess (action.payload));
  } catch (error) {
    yield put(actions.updateEmployeeFailure(error.message));
  }
}



//FOR FETCHING EMPLOYEES 
function* fetchEmployeeSaga(action) {
    try {
      
        const response = yield call(axiosInstance.get, `/emp/list/${action.payload}`);
        ////console.log(response.data);
        yield put(actions.fetchEmployeeSuccess(response.data.employees));
    } catch (error) {
        yield put(actions.fetchEmployeeFailure(error.message));
    }
}


//FOR DELETE EMPLOYEES
function* deleteEmployeeSaga(action) {
    try {
      ////console.log(action.payload);
    const response = yield call(axiosInstance.patch, `/emp/toggle-status/${action.payload.id}`);
    ////console.log(response);
    ////console.log(response.data);
    
      // Check the response data to determine if the deletion was successful
      if (response.data) {
        // If the response indicates success, dispatch the success action
        yield put(actions.deleteEmployeeSuccess(action.payload.id)); 
        ////console.log("Deleted employee ID:", action.payload.id);
      } else {
        // If the deletion was not successful, dispatch failure with the error message
        yield put(actions.deleteEmployeeFailure('Failed to delete employee'));
      }
    } catch (error) {
      // Handle any errors (e.g., network errors)
      yield put(actions.deleteEmployeeFailure(error.message)); // Pass the error message to failure action
    }
  }
  



export default function* watchFetchData()  {
  yield takeEvery(types.UPDATE_EMPLOYEE_REQUEST, updateEmployees);
  yield takeEvery(types.FETCH_EMPLOYEE_REQUEST, fetchEmployeeSaga);
  yield takeEvery(types.DELETE_EMPLOYEE_REQUEST, deleteEmployeeSaga);
}

